export default function Settings() {
  return (
    <div className="p-4 md:p-6 max-w-2xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Налаштування</h1>
        <p className="text-slate-400 text-sm mt-0.5">Профіль та параметри додатку</p>
      </div>

      <div className="card p-5 space-y-4">
        <h2 className="font-medium">Профіль</h2>
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-slate-700 flex items-center justify-center text-xl font-medium">
            В
          </div>
          <div>
            <div className="font-medium">Вадим</div>
            <div className="text-sm text-slate-500">Telegram ID: ••••••</div>
          </div>
        </div>
      </div>

      <div className="card p-5 space-y-4">
        <h2 className="font-medium">Цілі</h2>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-xs text-slate-400">Денна норма калорій</label>
            <input
              type="number"
              defaultValue={2200}
              className="mt-1 w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm outline-none focus:border-violet-500"
            />
          </div>
          <div>
            <label className="text-xs text-slate-400">Вода (мл)</label>
            <input
              type="number"
              defaultValue={2000}
              className="mt-1 w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm outline-none focus:border-violet-500"
            />
          </div>
          <div>
            <label className="text-xs text-slate-400">Бюджет на місяць (₴)</label>
            <input
              type="number"
              defaultValue={40000}
              className="mt-1 w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm outline-none focus:border-violet-500"
            />
          </div>
        </div>
      </div>

      <div className="card p-5">
        <h2 className="font-medium mb-3">Про додаток</h2>
        <p className="text-sm text-slate-400">
          Plnly v0.1.0 — Telegram Mini App + AI-помічник.  
          Архітектура: Cloudflare + Supabase. $0 на старті.
        </p>
      </div>
    </div>
  )
}
